import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/Auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Inbox from "@/pages/Inbox";
import SlotMap from "@/pages/SlotMap";
import Send from "@/pages/Send";
import Devices from "@/pages/Devices";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Activity from "@/pages/Activity";
import Transfer from "@/pages/Transfer";
import IpAccess from "@/pages/IpAccess";

const ROUTES = [["/", ["inbox"]], ["/transfer", ["transfer"]], ["/slot", ["slots"]], ["/kirim", ["send_sms", "send_ussd"]], ["/aktivitas", ["activity"]], ["/device", ["devices"]], ["/pengaturan", ["settings"]], ["/ip", ["ip_whitelist"]]];

function NoAccess() {
  return <div data-testid="no-access" className="p-10 text-slate-500">Akun Anda belum diberi akses ke menu apa pun. Hubungi admin.</div>;
}

function Protected({ children, admin, perm }) {
  const { user, isAdmin, can } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-slate-500 font-mono text-sm">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if ((admin && !isAdmin) || (perm && !can(...perm))) {
    const first = ROUTES.find(([, p]) => can(...p));
    return first && first[0] !== window.location.pathname ? <Navigate to={first[0]} replace /> : <NoAccess />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Protected perm={["inbox"]}><Inbox /></Protected>} />
            <Route path="/transfer" element={<Protected perm={["transfer"]}><Transfer /></Protected>} />
            <Route path="/slot" element={<Protected perm={["slots"]}><SlotMap /></Protected>} />
            <Route path="/kirim" element={<Protected perm={["send_sms", "send_ussd"]}><Send /></Protected>} />
            <Route path="/aktivitas" element={<Protected perm={["activity"]}><Activity /></Protected>} />
            <Route path="/device" element={<Protected perm={["devices"]}><Devices /></Protected>} />
            <Route path="/pengaturan" element={<Protected perm={["settings"]}><Settings /></Protected>} />
            <Route path="/ip" element={<Protected perm={["ip_whitelist"]}><IpAccess /></Protected>} />
            <Route path="/akun" element={<Protected admin><Users /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
